var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14207 0 0 3.14207 0 7C0 10.8579 3.14207 14 7 14C10.8579 14 14 10.8579 14 7C14 3.14207 10.8579 0 7 0ZM7 11.6667C6.56432 11.6667 6.22222 11.3246 6.22222 10.8889V6.22222C6.22222 5.78654 6.56432 5.44444 7 5.44444C7.43568 5.44444 7.77778 5.78654 7.77778 6.22222V10.8889C7.77778 11.3246 7.43568 11.6667 7 11.6667ZM7 4.51111C6.48654 4.51111 6.06667 4.09124 6.06667 3.57778C6.06667 3.06432 6.48654 2.64444 7 2.64444C7.51346 2.64444 7.93333 3.06432 7.93333 3.57778C7.93333 4.09124 7.51346 4.51111 7 4.51111Z",
    fill: "#202040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a4df7c47b53e438cf08fd70dec4279a4.svg";
export { ForwardRef as ReactComponent };